import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import { Client } from '../pages/';
import ClientData from '../pages/client/ClientData';
import Participants from '../pages/client/Participants';
import Settlement from '../pages/client/Settlement';
import Groups from '../pages/client/Groups';
import EnrollmentForm from '../sections/landing/order-forms/EnrollmentForm';

import { LandingRoutes } from '.';

export default () => (
  <Routes>
    <Route path="*" element={<Navigate to="/client" />} />

    <Route path="/client" element={<Client />}>
      <Route path="" element={<ClientData />}/>
      {/* <Route path="participants" element={<Participants />}/> */}
      <Route path="settlement" element={<Settlement />}/>
      <Route path="groups" element={<Groups />}/>
    </Route>
    <Route path="zapisy" element={<EnrollmentForm formIdentifier={'zapisy'} />}/>
  </Routes>
);
